module.exports = __webpack_public_path__ + "static/media/44_manual.4d5eb690.png";